var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChecked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "-1 -1 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Slice 1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(2.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#92BB3E",
    x: 0,
    y: 0,
    width: 20,
    height: 20,
    rx: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.75,16.9384766 C8.30175781,16.9384766 7.96777344,16.7714844 7.66015625,16.4111328 L4.09179688,12.0166016 C3.84570312,11.7265625 3.7578125,11.4716797 3.7578125,11.1816406 C3.7578125,10.53125 4.24121094,10.0654297 4.90039062,10.0654297 C5.29589844,10.0654297 5.56835938,10.1972656 5.83203125,10.5224609 L8.71484375,14.1875 L14.3398438,5.26660156 C14.6123047,4.82714844 14.8935547,4.66894531 15.3505859,4.66894531 C16.0097656,4.66894531 16.484375,5.13476562 16.484375,5.77636719 C16.484375,6.02246094 16.4052734,6.27734375 16.2207031,6.55859375 L9.84863281,16.3671875 C9.59375,16.7539062 9.22460938,16.9384766 8.75,16.9384766 Z",
    id: "\\u2713",
    fill: "#FFFFFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChecked);
export default __webpack_public_path__ + "static/media/checked.264117366817ce8b3c2ed5232ba73c19.svg";
export { ForwardRef as ReactComponent };